// 5-stage horizontal tracker with connector fill. Used on ApplicationDetail.

import { useZh } from '../../lib/useProduct';
import { stageLabel } from '../../lib/stageLabels';
import type { ApplicationStage } from '../../lib/types';

const STAGES: ApplicationStage[] = ['Evaluated', 'Applied', 'Phone screen', 'Interview', 'Offer'];

interface Props {
  currentStage: ApplicationStage;
}

export default function StageTracker({ currentStage }: Props) {
  const zh = useZh();
  const currentIdx = STAGES.indexOf(currentStage);
  return (
    <div className="card" style={{ padding: '20px 24px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 0, position: 'relative' }}>
        {STAGES.map((s, i) => {
          const done = i <= currentIdx;
          const active = i === currentIdx;
          return (
            <div key={s} style={{ position: 'relative', textAlign: 'center' }}>
              {i > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    left: '-50%',
                    right: '50%',
                    top: 11,
                    height: 2,
                    background: done ? 'var(--pri)' : 'var(--line)',
                  }}
                />
              )}
              <div
                style={{
                  position: 'relative',
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  margin: '0 auto',
                  background: done ? 'var(--pri)' : 'var(--surface)',
                  border: `2px solid ${done ? 'var(--pri)' : 'var(--line)'}`,
                  display: 'grid',
                  placeItems: 'center',
                  color: '#fff',
                  fontSize: 11,
                  fontWeight: 600,
                }}
              >
                {done && (active ? '•' : '✓')}
              </div>
              <div
                style={{
                  fontSize: 11.5,
                  marginTop: 8,
                  fontWeight: active ? 600 : 400,
                  color: active ? 'var(--pri)' : done ? 'var(--ink)' : 'var(--ink3)',
                }}
              >
                {stageLabel(s, zh)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
